import axios from 'axios';

axios.defaults.baseURL = '/api/v1';
if (process.env.NODE_ENV !== 'production') {
  axios.defaults.withCredentials = true;
}

export default axios;
